import { cn, Toggle } from "@z/ui";
import { useAllTags } from "./tags";

export type TagFilterBarProps = {
  /** The active tag, or `null` for no filter. */
  value: string | null;
  onChange: (tag: string | null) => void;
  className?: string;
};

/**
 * Every tag in use across notes as toggle chips, most used first. One tag is active at a
 * time; pressing it again clears the filter. Renders nothing when no note is tagged.
 */
export function TagFilterBar({ value, onChange, className }: TagFilterBarProps) {
  const tags = useAllTags();
  if (tags.length === 0) return null;
  const active = value?.toLowerCase();
  return (
    <div
      role="group"
      aria-label="Filter by tag"
      data-slot="tag-filter-bar"
      className={cn("flex flex-wrap items-center gap-1 px-2 py-1.5", className)}
    >
      {tags.map(({ tag, count }) => {
        const pressed = active === tag.toLowerCase();
        return (
          <Toggle
            key={tag}
            size="sm"
            variant="outline"
            pressed={pressed}
            onPressedChange={(next) => onChange(next ? tag : null)}
            className="h-6 gap-1 rounded-full px-2 font-normal"
          >
            {tag}
            <span className="text-fg-faint">{count}</span>
          </Toggle>
        );
      })}
    </div>
  );
}
